exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-search .b-dropdown-form{padding:0 5px!important}.select-search ul{width:90%!important}.select-search .dropdown-toggle,.select-search ul li button{width:100%!important;text-overflow:ellipsis!important;overflow:hidden}.back-orange{background-color:#ff4500!important}.select-search .back-orange button.dropdown-item{color:#fff!important}", ""]);

// exports
